import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c485886c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "post" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "post__title" }, "Post Something", -1))
const _hoisted_3 = { class: "post__text-area" }
const _hoisted_4 = /*#__PURE__*/_createStaticVNode("<div class=\"post__link\" data-v-c485886c><ul class=\"post__link-list\" data-v-c485886c><li class=\"post__link-item\" data-v-c485886c><a href=\"javascript:void(0);\" data-v-c485886c><i class=\"icon icon-take-pic\" data-v-c485886c></i></a></li><li class=\"post__link-item\" data-v-c485886c><a href=\"javascript:void(0);\" data-v-c485886c><i class=\"icon icon-image\" data-v-c485886c></i></a></li><li class=\"post__link-item\" data-v-c485886c><a href=\"javascript:void(0);\" data-v-c485886c><i class=\"icon icon-tablet\" data-v-c485886c></i></a></li><li class=\"post__link-item\" data-v-c485886c><a href=\"javascript:void(0);\" data-v-c485886c><i class=\"icon icon-upload-file\" data-v-c485886c></i></a></li></ul></div>", 1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_el_input, {
        modelValue: _ctx.message,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.message) = $event)),
        autosize: "",
        type: "textarea",
        placeholder: "Write something"
      }, null, 8, ["modelValue"])
    ]),
    _hoisted_4
  ]))
}